export const EDITOR_HEIGHT = {
  min: 'min',
  max: 'max',
  stretch: 'stretch',
};
